import React, { useEffect } from 'react';
import { Portal } from '@vfit/shared/components';
import CheckoutEnergy from './checkoutEnergy';
import { ICheckoutEnergyModalProps } from './checkoutEnergy.models';

const CheckoutEnergyModal = ({
  isOpen,
  handleClose,
  backgroundImage,
  isLoadingCart,
  isErrorOnPaymentShowErrorModal,
  isOnResetUser,
  isErrorOnPayment,
  hideCards,
}: ICheckoutEnergyModalProps) => {
  useEffect(() => {
    const closeOnEscapeKey = (e: KeyboardEvent) => (e.key === 'Escape' ? handleClose() : null);
    document.body.addEventListener('keydown', closeOnEscapeKey);
    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKey);
    };
  }, [handleClose]);

  if (!isOpen) return null;

  return (
    <Portal wrapperId="checkout-energy">
      <CheckoutEnergy
        isOpen
        backgroundImage={backgroundImage}
        handleClose={handleClose}
        isLoadingCart={isLoadingCart}
        isErrorOnPayment={isErrorOnPayment}
        isErrorOnPaymentShowErrorModal={isErrorOnPaymentShowErrorModal}
        isOnResetUser={isOnResetUser}
        hideCards={hideCards}
      />
    </Portal>
  );
};

export default CheckoutEnergyModal;
